var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-alert',{attrs:{"show":_vm.dismissCountDown,"dismissible":"","fade":"","variant":_vm.variant},on:{"dismissed":_vm.clear,"dismiss-count-down":function($event){5}}},[_c('p',{staticClass:"font-weight-normal"},[_vm._v(_vm._s(_vm.msg))])])
}
var staticRenderFns = []

export { render, staticRenderFns }